import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common/index';
import { AppSettings } from 'app/infrastructure/settings/index';

@Injectable()
export class ChargeService {
    constructor(private http: AuthHttp) { }

    getChargesByDivision(divisionCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("divisionCode", divisionCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "Charge/GetChargesByDivision", options)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/om/charge.service.ts